import React from "react";

import { ListDecryptedConsigneeResult } from "@/services/api/order";
import OrderDTO from "@/dto/order/OrderDTO";
import ShopDTO from "@/dto/shop/ShopDTO";
import { getRealOrderOriginalId } from "@/utils/OrderUtils";

export interface UseListDecryptedConsignee {
    shop: ShopDTO;

    onSuccess?(params: ListDecryptedConsigneeResult[]);
}

export enum DecryptedType {
    /**
     * 完整解密
     */
    ALL = "ALL",
    /**
     * 仅查看姓名和地址
     */
    NAME_AND_STREET = "NAME_AND_STREET",
    /**
     * 平台后台
     */
    PLATFORM = "PLATFORM",
}

export function getTbQnOrderDetailUrl(order: OrderDTO) {
    const orderOriginalId = getRealOrderOriginalId(order);

    return `https://qn.taobao.com/home.htm/trade-platform/tp/detail?bizOrderId=${orderOriginalId}`;
}
